export const Utility = {
  testImage(url, callback) {
    // let timeout = 300;
    // let timedOut = false,
    //   timer;
    // let img = new Image();
    // img.onerror = img.onabort = function() {
    //   if (!timedOut) {
    //     clearTimeout(timer);
    //     callback("error");
    //   }
    // };
    // img.onload = function() {
    //   if (!timedOut) {
    //     clearTimeout(timer);
        callback("success");
    //   }
    // };
    // img.src = url;
    // timer = setTimeout(function() {
    //   timedOut = true;
    //   // reset .src to invalid URL so it stops previous
    //   // loading, but doesn't trigger new load
    //   img.src = "//!!!!/test.jpg";
    //   callback("timeout");
    // }, timeout);
  },
  minMax(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
};
